/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createRedPocketEnvelope} from '../api'

export const useMutationCreateRedPocketEnvelope = createReactQueryMutationHook('createRedPocketEnvelope', createRedPocketEnvelope)
